export enum TutorialId {
    UI_Welcome,
    UI_Objective,
    UI_Market,
    UI_Gold,
    UI_Actions,
    UI_Cells,
    UI_NextRound,
    UI_Incoming,
	BasicInstructions,
	MultipleCells,
	LevellingUp,
	CombiningCells
}

export interface TooltipInfo {
    id: TutorialId;
    title: string;
    text: string;
    videoLink?: string;
    imageLink?: string;
}

export enum Position {
    TOP,
    BOTTOM,
    LEFT,
    RIGHT,
    CENTER
}

export interface TutorialPositions {
    x: number;
    y: number;
    radius: number;
    text: string;
    textPosition: Position;
}

export const allTutorials = [
    TutorialId.UI_Welcome,
    TutorialId.UI_Objective,
    TutorialId.UI_Market,
    TutorialId.UI_Gold,
    TutorialId.UI_Actions,
    TutorialId.UI_Cells,
    TutorialId.UI_NextRound,
    TutorialId.UI_Incoming,
    TutorialId.BasicInstructions,
    TutorialId.MultipleCells,
    TutorialId.LevellingUp,
    TutorialId.CombiningCells
];

export const tooltipInfo: TooltipInfo[] = [
    {
        id: TutorialId.UI_Welcome,
        title: "Welcome to Auto Immune!",
        text: "In this game, you will be defending your blood cells from viruses. Survive 12 rounds to win the game!",
        imageLink: "assets/tutorial/tut_blood.png"
    },
    {
        id: TutorialId.UI_Objective,
        title: "Viruses are coming!",
        text: "Each round, viruses will attack your blood cells. After each round, the viruses grow in number!",
        imageLink: "assets/tutorial/tut_objective.png"
    },
    {
        id: TutorialId.UI_Market,
        title: "The Market",
        text: "You must defend yourself by recruiting immune cells from the market. Press next for an explaination of each section.",
        imageLink: "assets/tutorial/tut_marker.png"
    },
    {
        id: TutorialId.UI_Gold,
        title: "Gold Indicator",
        text: "This is your gold. You lose all your gold at the end of each round, and gain more gold as the rounds progress.",
        imageLink: "assets/tutorial/tut_gold.png"
    },
    {
        id: TutorialId.UI_Cells,
        title: "Immune Cells",
        text: "Purchase cells here! The indicator at the bottom displays how many cells you have on the field and the max cells you can field.",
        imageLink: "assets/tutorial/tut_cells.png"
    },
    {
        id: TutorialId.UI_Actions,
        title: "Market Actions",
        text: "The shape on the top left is your current market level. Use the buttons to gain exp, refresh the cells on offer, or lock the shop for the next round.",
        imageLink: "assets/tutorial/tut_actions.png"
    },
    {
        id: TutorialId.UI_NextRound,
        title: "Next Round",
        text: "This button advances to the next round. Survive 12 rounds to win the game!",
        imageLink: "assets/tutorial/tut_next_round.png"
    },
    {
        id: TutorialId.UI_Incoming,
        title: "Check Incoming Viruses",
        text: "Before you go to the next round, you can check this panel to see what kind and how many viruses will appear.",
        imageLink: "assets/tutorial/tut_incoming.png"
    },
    {
        id: TutorialId.BasicInstructions,
        title: "Using the market",
        text: "Purchase an immune cell by clicking on an immune cell and dragging it to the battlefield. You can rotate the cell by hovering over the cell and dragging the arrow.",
        videoLink: "assets/tutorial/place-wall.mp4"
    },
    {
        id: TutorialId.MultipleCells,
        title: "Selecting Multiple Immune Cells",
        text: "You can select multiple immune cells by clicking and dragging on the battlefield. You can rotate them the same way as an individual cell.",
        videoLink: "assets/tutorial/select-and-rotate.mp4"
    },
    {
        id: TutorialId.LevellingUp,
        title: "Leveling up",
        text: "As you purchase experience you can level up! When you reach the next level, you get a larger selection of immune cells to purchase and higher tier immune cells are available.",
        videoLink: "assets/tutorial/level-up-with-arrows.mp4"
    },
    {
        id: TutorialId.CombiningCells,
        title: "Combining Immune Cells",
        text: "You can combine two immune cells of the same name to create a more powerful cell. You can combine two cells by dragging one cell on top of another from either the shop or from the battlefield.",
        videoLink: "assets/tutorial/combine-and-reward.mp4"
    }
];

export enum TutorialStep {
    Welcome,
    Objective,
    Market,
    Gold,
    Cells,
    Actions,
    /*
    NextRound,
    Incoming,
    Blood
    */
}

export const TutorialStrings: Record<TutorialStep, TutorialPositions> = {
    [TutorialStep.Welcome]: {
        x: 50,
        y: 50,
        radius: 10,
        text: "Welcome to Auto Immune!",
        textPosition: Position.CENTER
    },
    [TutorialStep.Objective]: {
        x: 920,
        y: 410,
        radius: 10,
        text: "The goal is to survive 12 rounds of virus attacks!",
        textPosition: Position.CENTER
    },
    [TutorialStep.Market]: {
        x: 100,
        y: 100,
        radius: 10,
        text: "This is the market. You can purchase immune cells here.",
        textPosition: Position.RIGHT
    },
    [TutorialStep.Gold]: {
        x: 100,
        y: 100,
        radius: 10,
        text: "You purchase immune cells with proteins. You gain proteins each round.",
        textPosition: Position.RIGHT
    },
    [TutorialStep.Cells]: {
        x: 100,
        y: 100,
        radius: 10,
        text: "",
        textPosition: Position.RIGHT
    },
    [TutorialStep.Actions]: {
        x: 100,
        y: 100,
        radius: 10,
        text: "You can gain experience, refresh the shop, or lock the shop.",
        textPosition: Position.RIGHT
    },
};